/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-operations-chevron-sort-down': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M10 17.5l-4.375-4.375.875-.875 3.5 3.5 3.5-3.5.875.875z"/>'
  }
})
